import React from "react";
import SubLayout from "../SubLayout/SubLayout";
import {
    IconStar,
    IconMapPin,
    IconLock,
    IconClock,
    IconSparkles,
    IconUserCheck,
    IconWhatsApp,
} from "../icons/Icons";

const WHATSAPP_URL = "https://wa.me/640997403";

const items = [
    {
        Icon: IconMapPin,
        title: "Servicio a domicilio",
        desc: "Nos desplazamos hasta donde nos necesites.",
    },
    {
        Icon: IconLock,
        title: "Citas privadas",
        desc: "Atención exclusiva y sin interrupciones.",
    },
    {
        Icon: IconClock,
        title: "Fuera de horario",
        desc: "Antes de abrir, después de cerrar o en horarios especiales.",
    },
    {
        Icon: IconSparkles,
        title: "Eventos especiales",
        desc: "Bodas, sesiones de fotos, eventos privados y más.",
    },
    {
        Icon: IconUserCheck,
        title: "Atención personalizada",
        desc: "Asesoramiento y servicio adaptado a cada cliente.",
    },
];

function ServiciosVip() {
    return (
        <SubLayout
            icon={IconStar}
            title="Servicios VIP"
            intro="¿Buscas una experiencia más exclusiva?"
            centered
        >
            <div className="info-list">
                {items.map(({ Icon, title, desc }) => (
                    <div className="info-item" key={title}>
                        <span className="info-ico">
                            <Icon />
                        </span>
                        <div>
                            <h3>{title}</h3>
                            <p>{desc}</p>
                        </div>
                    </div>
                ))}
            </div>

            <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="wa-cta"
            >
                <IconWhatsApp />
                Consultar disponibilidad y precio por WhatsApp
            </a>
        </SubLayout>
    );
}

export default ServiciosVip;
